import { css } from '@repo/pandacss/css';

export const proConsListItemBase = css.raw({
  display: 'flex',
  gap: '2',
  px: '1',
  py: '[2px]',
  alignItems: 'flex-start',
});

const proConsBulletClassBase = css.raw({
  marginTop: '[5px]',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSize: '[14px]',
  borderRadius: 'half',
  flexShrink: 0,
  color: 'common.white',
});

export const proBulletClass = css(proConsBulletClassBase, {
  backgroundColor: 'greens.main',
});

export const conBulletClass = css(proConsBulletClassBase, {
  backgroundColor: 'reds.main',
});
